import z from "zod";

const flag = z
  .string()
  .optional()
  .transform((value) => undefined !== value && "false" !== value);

export const projectEditorDataSchema = z.object({
  projectId: z
    .string()
    .optional()
    .transform((value) => {
      const id = Number(value);

      return value && Number.isInteger(id) && id > 0 ? id : null;
    }),

  /** What an empty form opens as; a loaded project says it for itself. */
  type: z
    .enum(["subscription", "intervention"])
    .optional()
    .transform((value) => value ?? "intervention"),

  contained: flag,
  open: flag,

  /** Which shell an uncontained editor opens in. */
  shell: z
    .enum(["dialog", "window"])
    .optional()
    .transform((value) => value ?? "dialog"),
});

export type ProjectEditorDataProps = z.infer<typeof projectEditorDataSchema>;
